import { useState } from "react";
import { useIntl } from "react-intl";
import type { DocumentResource } from "@/lib/document-resource";
import { openDocumentResource } from "@/stores/document-preview-store";
import { userErrorMessage } from "@/lib/user-error";
import { DocumentThumbnail } from "./DocumentThumbnail";
import { DocumentOpenButton } from "./DocumentOpenButton";

export function DocumentImage({ file, previewUrl, className, onSelect }: {
  file: DocumentResource; previewUrl?: string | null; className: string; onSelect?: () => void;
}) {
  const intl = useIntl();
  const [error, setError] = useState<unknown>();
  const open = () => { setError(undefined); void openDocumentResource(file).catch(setError); };
  return <div className="relative">
    <button type="button" className={`block ${className}`} onClick={onSelect ?? open} aria-label={file.name}>
      <DocumentThumbnail fit="cover" resource={file} previewSrc={previewUrl} fallback={<span aria-hidden>📄</span>} />
    </button>
    <span className="absolute bottom-1 right-1 rounded bg-page"><DocumentOpenButton resource={file} name={file.name} onOpen={open} /></span>
    {error ? <p role="alert" className="text-smycles-meta">{userErrorMessage(intl, error)}</p> : null}
  </div>;
}
